import { render } from "./RankingsList.vue?vue&type=template&id=4a61af24"
import script from "./RankingsList.vue?vue&type=script&lang=js"
export * from "./RankingsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__